import { atomWithStorage } from "jotai/utils";
import type { ExpenseCategory } from "./global";

export type User = {
  email: string;
  name: string;
  googleId: string;
  picture: string;
  family_name: string;
  id: string;
  categories?: ExpenseCategory[];
};

export const userAtom = atomWithStorage<User | null>("user", null);
